import data from './pcdf_mobile.json';

/**
 * data from the pcdf.json, object 371 in pcdf spec
 */
export interface RdsapControlsHeatersPdcbData994 {
    id: string,
    mfcRefNo: string,
    status: string,
    brandName: string,
    modelName: string,
    modelQualifier: string,
    mfcFirstYear: string,
    mfcFinalYear: string,
    controllerType: string,
    category: string,
    fuel: string,
    control: string,
    efficiency: string,
}

export interface RdsapControlsHeatersPdcb994 {
    data: {
      371: RdsapControlsHeatersPdcbData994[];
    };
  }
  
export const rdsapControlsHeatersPdcbData994 = data as RdsapControlsHeatersPdcb994;